// extracted by mini-css-extract-plugin
export default {"cover":"NeedHelpPrompt_cover__A1z8S","container":"NeedHelpPrompt_container__eI6U6","secondary":"NeedHelpPrompt_secondary__JmyZ0","circle":"NeedHelpPrompt_circle__XDWZi"};